import { ConstructClassWithPrivateMembers } from '../helpers/ClassWithPrivateMembers';
import { GetPropertyDescriptor } from '../helpers/object-helpers';
var propertiesFunctionMap = new WeakMap();
export function GetOrCreatePropertiesFunctionMap(instance) {
    if (propertiesFunctionMap.has(instance)) {
        return propertiesFunctionMap.get(instance);
    }
    else {
        var map = new Map();
        propertiesFunctionMap.set(instance, map);
        return map;
    }
}
export function GetOrCreateInstanceFunctionProperty(instance, propertyKey, callback, functionsMap) {
    if (functionsMap === void 0) { functionsMap = GetOrCreatePropertiesFunctionMap(instance); }
    if (functionsMap.has(propertyKey)) {
        return functionsMap.get(propertyKey);
    }
    else {
        var _callback = callback.bind(instance);
        functionsMap.set(propertyKey, _callback);
        return _callback;
    }
}
export var INSTANCE_PRIVATE = Symbol('instance-private');
export function ConstructInstance(instance, _instance, proto) {
    if (proto === void 0) { proto = instance.constructor; }
    ConstructClassWithPrivateMembers(instance, INSTANCE_PRIVATE);
    var privates = instance[INSTANCE_PRIVATE];
    privates.instance = _instance;
    privates.proto = proto;
    privates.functionsMap = GetOrCreatePropertiesFunctionMap(privates.instance);
}
export function InstanceGetPropertyDescriptor(instance, propertyKey) {
    return GetPropertyDescriptor(instance[INSTANCE_PRIVATE].proto, propertyKey);
}
export function InstanceProp(instance, propertyKey) {
    var privates = instance[INSTANCE_PRIVATE];
    var descriptor = InstanceGetPropertyDescriptor(instance, propertyKey);
    if (descriptor === void 0) {
        return void 0;
    }
    else {
        if (typeof descriptor.get === 'function') {
            return descriptor.get.call(privates.instance);
        }
        else if (typeof descriptor.set === 'function') {
            throw new Error("The property " + String(propertyKey) + " is a pure setter (not gettable)");
        }
        else if (typeof descriptor.value === 'function') {
            return GetOrCreateInstanceFunctionProperty(privates.instance, propertyKey, descriptor.value, privates.functionsMap);
        }
        else {
            return descriptor.value;
        }
    }
}
export function InstanceAssign(instance, propertyKey, value) {
    var privates = instance[INSTANCE_PRIVATE];
    var descriptor = InstanceGetPropertyDescriptor(instance, propertyKey);
    if ((descriptor !== void 0) && (typeof descriptor.set === 'function')) {
        return descriptor.set.call(privates.instance, value);
    }
    else {
        privates.instance[propertyKey] = value;
    }
}
export function InstanceGet(instance, propertyKey) {
    var privates = instance[INSTANCE_PRIVATE];
    var descriptor = InstanceGetPropertyDescriptor(instance, propertyKey);
    if ((descriptor !== void 0) && (typeof descriptor.get === 'function')) {
        return descriptor.get.call(privates.instance);
    }
    else {
        throw new Error("The property " + String(propertyKey) + " is not a getter");
    }
}
export function InstanceSet(instance, propertyKey, value) {
    var privates = instance[INSTANCE_PRIVATE];
    var descriptor = InstanceGetPropertyDescriptor(instance, propertyKey);
    if ((descriptor !== void 0) && (typeof descriptor.set === 'function')) {
        return descriptor.set.call(privates.instance, value);
    }
    else {
        throw new Error("The property " + String(propertyKey) + " is not a setter");
    }
}
export function InstanceApply(instance, propertyKey, args) {
    if (args === void 0) { args = []; }
    var privates = instance[INSTANCE_PRIVATE];
    var descriptor = InstanceGetPropertyDescriptor(instance, propertyKey);
    if ((descriptor !== void 0) && (typeof descriptor.value === 'function')) {
        return descriptor.value.apply(privates.instance, args);
    }
    else {
        throw new Error("The property " + String(propertyKey) + " is not a function");
    }
}
var Instance = (function () {
    function Instance(instance, proto) {
        ConstructInstance(this, instance, proto);
    }
    Object.defineProperty(Instance.prototype, "instance", {
        get: function () {
            return this[INSTANCE_PRIVATE].instance;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Instance.prototype, "proto", {
        get: function () {
            return this[INSTANCE_PRIVATE].proto;
        },
        enumerable: true,
        configurable: true
    });
    Instance.prototype.prop = function (propertyKey) {
        return InstanceProp(this, propertyKey);
    };
    Instance.prototype.assign = function (propertyKey, value) {
        return InstanceAssign(this, propertyKey, value);
    };
    Instance.prototype.call = function (propertyKey) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        return this.apply(propertyKey, args);
    };
    Instance.prototype.get = function (propertyKey) {
        return InstanceGet(this, propertyKey);
    };
    Instance.prototype.set = function (propertyKey, value) {
        return InstanceSet(this, propertyKey, value);
    };
    Instance.prototype.apply = function (propertyKey, args) {
        return InstanceApply(this, propertyKey, args);
    };
    return Instance;
}());
export { Instance };
//# sourceMappingURL=implementation.js.map